/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import StoredPlotlyFigure from '@/components/charts/StoredPlotlyFigure';
import type { StoredPlotlyResponse } from '@/types/eeCheck';

interface StaticStoredPlotlyPlotProps {
    figure: StoredPlotlyResponse | null;
    fillParent?: boolean;
}

function StaticStoredPlotlyPlot(props: StaticStoredPlotlyPlotProps) {
    return <StoredPlotlyFigure {...props} />;
}

export default StaticStoredPlotlyPlot;
